import { Link, useLocation, useNavigate } from 'react-router-dom';
import { transferNoticeUrl } from '../../utils/transferNotice';
import MobileLayout from '../../components/Public/MobileLayout';
import headset from '../../icon/headset.svg';
import { ToastContainer } from 'react-toastify';
import { useContext, useEffect, useState } from 'react';
import ChannelTalkContext from '../../context/ChannelTalkContext';
import { successToast } from '../../utils/toast';
import { onToggleModal } from '../../utils/utils';
import ResponsiveConfirmModal from '../../components/Modal/ResponsiveConfirmModal';
import SUCCESS from '../../icon/success.svg';
import ResponsivePolicySheet from '../../components/Modal/ResponsivePolicySheet';
import PrivacyRevisionNotice from '../../components/Public/PrivacyRevisionNotice';
import ResumeTransitionNotice from '../../components/Public/ResumeTransitionNotice';
import useUpdateTitle from '../../hooks/updateTitle';
import { MOBILE_PRIVACY_POLICY, MOBILE_TERMS } from '../../utils/StaticVariable/mobilePolicyContent';
import Logo from '../../icon/vdream_logo_renewal.svg';
import LongArrow from '../../icon/mainPage_arrow.svg';

const ResponsiveMobileMainResume = () => {
  useUpdateTitle();
  const location = useLocation();
  const navigate = useNavigate();
  const { openChannelChat } = useContext(ChannelTalkContext);

  const [isOpen, setIsOpen] = useState(false);
  const [state, setState] = useState('');
  const [modalType, setModalType] = useState('');

  useEffect(() => {
    if (location.state === 'active') {
      setIsOpen(true);
      setModalType('confirm');
      setState('active');
      navigate(location.pathname, { replace: true });
    } else if (location.state === 'inquiry') {
      setIsOpen(true);
      setModalType('confirm');
      setState('inquiry');
      navigate(location.pathname, { replace: true });
    } else if (location.state === 'delete') {
      successToast(<div>이력서 삭제가 완료되었습니다.</div>);
      navigate(location.pathname, { replace: true });
    } else if (location.state === 'recruitapply') {
      setIsOpen(true);
      setModalType('confirm');
      setState('recruitapply');
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  return (
    <MobileLayout>
      <main className="w-full h-full px-5 py-6">
        <PrivacyRevisionNotice />
        <ResumeTransitionNotice className="mt-3" />
        <img
          src={Logo}
          className="mx-auto mt-8 h-9"
        />
        <h1 className="text-[20px] font-bold text-center leading-[130%] tracking-[-0.01em] mb-5 mt-12">
          재택 근무를 희망하는 장애인 구직신청
        </h1>

        <div className="flex flex-col gap-4 mb-6">
          <a
            href={transferNoticeUrl("resume-write")}
            className="group bg-[#16C1B120] rounded-2xl py-9 px-7 cursor-pointer transition hover:bg-[#16C1B1] active:bg-[#16C1B1]"
            aria-label="이력서 등록하기 / 시각장애인인 경우 하단 간편문의를 이용해보세요"
          >
            <div className="text-left">
              <h2 className="text-[20px] mb-3 font-bold text-gray-900 group-hover:text-white group-active:text-white">
                이력서 등록
              </h2>
              <p className="text-[12px] text-gray-500 group-hover:text-white group-active:text-white mb-4">
                새로운 맞춤형 이력서를 등록 하시는 경우
              </p>
              <img
                src={LongArrow}
                className="ml-auto w-16 sm:w-20"
                alt="화살표"
              />
            </div>
          </a>
          {/* 
          <Link
            to="/resume/read"
            className="group bg-[#F4F4F4] rounded-2xl p-6 cursor-pointer transition hover:bg-[#16C1B1] active:bg-[#16C1B1]"
            aria-label="이력서 조회하기"
          >
            <div className="text-left">
              <h2 className="text-[16px] sm:text-[18px] mb-3 font-bold text-gray-900 group-hover:text-white group-active:text-white">
                이력서 조회
              </h2>
              <p className="text-[10px] sm:text-[12px] text-gray-500 group-hover:text-white group-active:text-white mb-4">
                이미 이력서를 등록 하신 경우
              </p>
              <img
                src={LongArrow}
                className="ml-auto w-16 sm:w-20"
                alt="화살표"
              />
            </div>
          </Link>
        </div>

        <div className="flex flex-col gap-4 mb-8">
          <Link
            to="/resume/recruitlist"
            className="group bg-[#C2CFFF] rounded-2xl p-6 cursor-pointer transition hover:bg-[#9bb0ff] active:bg-[#9bb0ff] relative"
          >
            <div className="text-left">
              <h2 className="text-[16px] sm:text-[18px] font-bold text-gray-900 group-hover:text-black group-active:text-black">
                채용공고
              </h2>
              <img
                src={incruit}
                className="absolute right-4 top-4 w-8 h-8 sm:w-10 sm:h-10"
                alt="채용공고"
              />
            </div>
          </Link> */}

          <button
            type="button"
            onClick={() => openChannelChat()}
            className="group bg-[#FFD26E] w-full rounded-2xl p-6 cursor-pointer transition hover:bg-[#FFCC00] active:bg-[#FFCC00] relative"
            aria-label="간편문의 하기"
          >
            <div className="text-left">
              <h2 className="text-[16px] sm:text-[18px] font-bold text-gray-900 group-hover:text-black group-active:text-black">
                간편문의
              </h2>
              <img
                src={headset}
                className="absolute right-4 top-4 w-8 h-8 sm:w-10 sm:h-10"
                alt="간편문의"
              />
            </div>
          </button>
        </div>

        <div className="text-right mt-8 font-medium text-[10px] sm:text-[12px]">
          <Link
            className="cursor-pointer"
            to="/resume/privacy-policy"
          >
            개인정보 처리방침
          </Link>
          <span> | </span>
          <span
            className="cursor-pointer"
            onClick={() => {
              onToggleModal(setIsOpen);
              setModalType('terms');
            }}
          >
            이용 약관
          </span>
        </div>
      </main>

      {isOpen && modalType === 'terms' && (
        <ResponsivePolicySheet
          isOpen={isOpen && modalType === 'terms'}
          onClose={() => {
            setIsOpen(false);
            setModalType('');
          }}
          title="이용 약관"
          mobileOnlyFooterLabel="닫기"
        >
          <div>{MOBILE_TERMS}</div>
        </ResponsivePolicySheet>
      )}

      {/* 이력서 작성 완료 modal */}
      {isOpen && modalType === 'confirm' && (
        <ResponsiveConfirmModal
          width="w-full max-w-[450px]"
          padding="py-[20px] md:pb-[32px] md:pt-[0px]"
          setIsOpen={setIsOpen}
          type="complete"
          title={
            <div className="flex gap-2 items-center justify-center">
              <img
                src={SUCCESS}
                width="24px"
                height="24px"
                aria-label=""
              />
              <p tabIndex="0">
                {state === 'active'
                  ? '이력서 등록이 완료됐습니다.'
                  : state === 'inquiry'
                    ? '문의 접수가 완료됐습니다.'
                    : '입사지원이 완료됐습니다.'}
              </p>
            </div>
          }
          content={
            <p
              className="text-left mx-6 mt-4 text-[10px] sm:text-[12px]"
              tabIndex="0"
            >
              {state === 'active' ? (
                <>
                  저희 브이드림에 이력서를 제출해 주셔서 감사합니다.
                  <br /> 수시 채용의 경우 매칭되는 기업이 있을 시 등록된 연락처로 개별 연락드리며,
                  <br /> 이력서 수정이 필요한 경우
                  <Link
                    className="text-[#3333FF] font-[450]"
                    to="/read"
                    aria-label="이력서 조회 페이지로 이동"
                  >
                    &nbsp;[이력서 조회]&nbsp;
                  </Link>
                  페이지를 이용하시기 바랍니다.
                </>
              ) : state === 'inquiry' ? (
                <>접수하신 내용은 확인 후, 입력하신 연락처를 통해 연락 드리도록 하겠습니다.</>
              ) : (
                ''
              )}
            </p>
          }
          onClose={() => {
            onToggleModal(setIsOpen);
            setState('');
            setModalType('');
          }}
        />
      )}

      <ToastContainer />
    </MobileLayout>
  );
};

export default ResponsiveMobileMainResume;
